import React, { useEffect } from "react";

import SettingsElement from "../../../ui-components/settings-element/settings-element";
import { fetchGraphQL } from "../../../services/api-raindrop";
import DateFormat from "../../../ui-components/date-format/date-format.tsx";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";

type PaymentMethod = {
  id: string;
  createdAt: string;
  state: string;
  lastFourDigits: string;
};

const PaymentMethodElement = ({
  paymentMethodId,
  lastFourDigits = "",
  isActive = true,
  createdAt = "2021-01-01",
}) => {
  return (
    <div
      id={paymentMethodId}
      className="flex flex-row w-full items-center gap-4"
    >
      <i className="fa fa-credit-card text-2xl" />
      <div className="flex flex-col">
        {lastFourDigits ? (
          <div className="flex flex-row gap-1 items-center font-bold">
            <div className="rounded-full bg-color-text-primary dark:bg-color-dark-text-primary h-1 w-1" />
            <div className="rounded-full bg-color-text-primary dark:bg-color-dark-text-primary h-1 w-1" />
            <div className="rounded-full bg-color-text-primary dark:bg-color-dark-text-primary h-1 w-1" />
            <div className="rounded-full bg-color-text-primary dark:bg-color-dark-text-primary h-1 w-1" />
            <div className="pl-1">{lastFourDigits}</div>
          </div>
        ) : (
          <div className="text-color-dark-text-secondary">
            No card number available
          </div>
        )}
        <div className="text-left text-sm text-color-dark-text-tertiary">
          <DateFormat dateIsoString={createdAt} />
        </div>
      </div>

      {isActive && (
        <div className="font-bold text-sm text-color-dark-text-secondary ml-auto">
          Active
        </div>
      )}
    </div>
  );
};

const RaindropSettingsPaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = React.useState<
    null | PaymentMethod[]
  >(null);

  useEffect(() => {
    fetchGraphQL(`
      query {
        paymentMethodObjects {
          id
          createdAt
          state
          lastFourDigits
        }
      }
    `)
      .then((result) => {
        if (result.data.paymentMethodObjects === undefined) {
          console.log("🔴 (RS-621) - ");
          return [];
        }
        setPaymentMethods(result.data.paymentMethodObjects);
      })
      .catch((error) => {
        console.error("🔴 (RD-697) - ", error);
      });
  }, []);

  return (
    <div className={"flex flex-col h-full overflow-visible gap-4 px-4 py-4"}>
      <RaindropBackButtonPanel />

      <h2 className="font-bold text-3xl text-left">Payment Methods</h2>

      <RaindropCard>
        <h3 className="font-bold text-sm uppercase w-full text-left text-color-dark-text-tertiary pt-4">
          Payment Methods
        </h3>

        {paymentMethods === null && (
          <div className="text-color-dark-text-secondary">
            Loading payment methods...
          </div>
        )}
        {paymentMethods !== null && paymentMethods.length === 0 && (
          <div className="text-color-dark-text-secondary">
            You have no payment methods yet
          </div>
        )}

        {paymentMethods &&
          paymentMethods.map((paymentMethod) => (
            <PaymentMethodElement
              key={paymentMethod.id}
              paymentMethodId={paymentMethod.id}
              lastFourDigits={paymentMethod.lastFourDigits}
              createdAt={paymentMethod.createdAt}
              isActive={paymentMethod.state === "PAYMENT_METHOD_STATE_ACTIVE"}
            />
          ))}
      </RaindropCard>

      <h3 className="font-bold text-sm uppercase text-left text-color-dark-text-tertiary pt-4">
        Add new payment methods
      </h3>
      <SettingsElement
        id={"settings-element-payment-methods"}
        title={"Add New Payment Method"}
        isLocked={false}
        to={"/raindrop/payment-method-add"}
        icon={"fa fa-plus"}
        isClickable={true}
      />
    </div>
  );
};

export default RaindropSettingsPaymentMethods;
